const FrameTitle = ({ children, game }) => {
    return (
        <div
            className={`absolute top-6 left-6 lg:top-8 lg:left-8 nobblee-regular text-xl lg:text-4xl ${game && 'rounded-lg py-2 px-4 bg-[#656D71]'}`}
        >
            {children}
        </div>
    );
};

export default FrameTitle;
